"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __importDefault(require("../store"));
var roles_json_1 = __importDefault(require("../../roles.json"));
exports.default = {
    methods: {
        /**
         * Checks if user has given permission.
         *
         * @param permission Permission name.
         * @return boolean
         */
        can: function (permission) {
            return (store_1.default.state.roles.includes(roles_json_1.default.superAdministrator) ||
                store_1.default.state.permissions.includes(permission));
        },
        /**
         * Checks if user has any permission of given in array.
         *
         * @param permissions Array of permission names.
         * @return boolean
         */
        canAny: function (permissions) {
            var _this = this;
            return (store_1.default.state.roles.includes(roles_json_1.default.superAdministrator) ||
                permissions.some(function (permission) { return _this.can(permission); }));
        },
        /**
         * Checks if user has all permissions given in array.
         *
         * @param permissions Array of permission names.
         * @return boolean
         */
        canAll: function (permissions) {
            var _this = this;
            return (store_1.default.state.roles.includes(roles_json_1.default.superAdministrator) ||
                permissions.every(function (permission) { return _this.can(permission); }));
        }
    }
};
